import React from 'react';
import './ProgramCard.css';
import { H2, H3, P, PhrosButton } from '../../Common';
import { Row, Col, Modal, message, Tag } from 'antd';
import { TRAINING_EXPERIENCE_LEVEL } from '../../constants';
import { connect } from 'react-redux';
import { addProgram } from '../../Redux/actions';
import { DataContext } from '../../Context/Data';


class ProgramCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
        }
        this.handleAddToCart = this.handleAddToCart.bind(this);
    }

    changeModalVisibility = () => {
        this.setState({
            modalOpen: !this.state.modalOpen
        })
    }

    handleAddToCart = () => {
        this.changeModalVisibility();
        this.props.addProgram(this.props.program);
        message.success(`${this.props.program?.Title} added to cart.`);
    }

    render() {
        return (
            <DataContext.Consumer>
                {
                    data => {
                        return (
                            <div className='Video-Card'>
                            <img src={this.props.program?.PictureURL} alt={this.props.program?.Title} className="Video-Card-Image" />
                            <div className='Video-Card-Container'>
                            <H3 text={`${this.props.program?.Title}`} />
                            {
                                this.props.program?.Price === 0 ?
                                <P text={`Free Workout Program, ${this.props.program?.ProgramLength} weeks`} />
                                :
                                <P text={`$${this.props.program?.Price} ${this.props.program?.Currency}, ${this.props.program?.ProgramLength} weeks`} />
                            }
                            <h3>Intensity: {this.props.program?.IntensityRating}/5  - {TRAINING_EXPERIENCE_LEVEL[this.props.program?.Level]}</h3>
                            <div className='Video-Card-Button'>
                                <PhrosButton onClick={this.changeModalVisibility} text='view' styles={{ background: data.websiteTemplate?.ColourPalette?.DARK }}/>
                            </div>
                            </div>
                            <Modal cancelText="Close"
                            footer={null}
                            okText="Add to Cart" width={800} visible={this.state.modalOpen} onOk={this.handleAddToCart} onCancel={this.changeModalVisibility}>
                                <Row gutter={[20,20]} style={{ padding: '10px' }}>
                                    <Col xs={24} sm={12}>
                                        <img src={this.props.program?.PictureURL} alt={this.props.program?.Title} className="Video-Card-Modal-Image" />
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <div>
                                        <H2 text={`${this.props.program?.Title}`} />
                                        {
                                            this.props.program?.Price === 0 ?
                                            <H3 text="Free Class" />
                                            :
                                            <H3 text={`$${this.props.program?.Price} ${this.props.program?.Currency}`} />
                                        }
                                        <P text={`${this.props.program?.ProgramLength} Week Workout Program`} />
                                        {
                                            this.props.program?.Categories.map((cat) => {
                                                return (
                                                <Tag
                                                color={data.websiteTemplate?.ColourPalette?.MEDIUM}
                                                className="Video-Card-Tag">
                                                    {cat}
                                                </Tag>
                                                );
                                            })
                                        }
                                        <div className='Video-Card-Space'>
                                        <P text={this.props.program?.Description} />
                                        </div>
                                        <div className='Video-Card-Space'>
                                        <P style={{ fontWeight: 400 }} text={`Intensity Rating: ${this.props.program?.IntensityRating}/5`} />
                                        </div>
                                        <div className='Video-Card-Space'>
                                        <P style={{ fontWeight: 400 }} text={`Level: ${TRAINING_EXPERIENCE_LEVEL[this.props.program?.Level]}`} />
                                        </div>
                                        <PhrosButton text='Add to Cart' onClick={this.handleAddToCart} styles={{ background: data.websiteTemplate?.ColourPalette?.MEDIUM }} />
                                        </div>
                                    </Col>
                                </Row>
                            </Modal>
                        </div>
                        )
                    }
                }
            </DataContext.Consumer>
        )
    }
}

const mapStateToProps = state => ({
    Programs: state.Programs,
});

const mapDispatchToProps = dispatch => ({
    addProgram: program => dispatch(addProgram(program))
})

export default connect(mapStateToProps, mapDispatchToProps)(ProgramCard);